import React from 'react'
import { ReactComponent as FacebookIcon } from 'images/facebook-icon-white.svg'
import { ReactComponent as TwitterIcon } from 'images/twitter-x-icon-white.svg'
import { ReactComponent as InstagramIcon } from 'images/instagram-icon-white.svg'
import { ReactComponent as YoutubeIcon } from 'images/youtube-icon-white.svg'
import { ReactComponent as SoundcloudIcon } from 'images/soundcloud-icon-white.svg'
import { useTheme } from '@emotion/react'

export default function Socials(){
    const theme = useTheme()
    return(
        <div
            className='d-flex'
            css={{
                '& svg': { width: 16, height: 16 },
                '& path': { fill: theme.colors.white, transition: 'fill .25s ease' },
                '& a:hover path': { fill: 'rgba(255 255 255 / .8)' },
                '& a': {
                    paddingBlock: 4,
                    paddingInline: 16,
                    [theme.queries.sm]: { paddingInline: 12 },
                    '@media(max-width: 375px)': {
                        '&:first-child': {
                            paddingLeft: 0
                        }
                    }
                },
            }}
        >
            <a href='https://www.facebook.com/pages/Numark/86785941084' target='_blank' rel='noreferrer'><FacebookIcon /></a>
            <a href='https://www.twitter.com/numark' target='_blank' rel='noreferrer'><TwitterIcon /></a>
            <a href='https://www.instagram.com/numark_dj/' target='_blank' rel='noreferrer'><InstagramIcon /></a>
            <a href='https://www.youtube.com/user/NumarkVideo' target='_blank' rel='noreferrer'><YoutubeIcon /></a>
            <a href='https://soundcloud.com/numarkdj' target='_blank' rel='noreferrer'><SoundcloudIcon /></a>
        </div>
    )
}
